export default __webpack_public_path__ + "123319c9071f36dfd040c36b8476d8e0.svg";